import React from 'react';
import { modules } from '../data/content';
export function Modules() {
  return <section className="bg-ivory px-3 py-4 sm:px-6" data-id="element-104" data-mp="1r63rh4h50cko">
      <div className="mx-auto max-w-2xl" data-id="element-105" data-mp="1r4sp993cbcvo">
        <h2 className="text-center font-heading text-[1.2rem] font-bold uppercase text-navy sm:text-[1.9rem]" data-id="element-106" data-mp="1vxc1o2qak1yw">
          What’s included
        </h2>
        <div className="mt-2 space-y-2" data-id="element-107" data-mp="20vncogsboiip">
          {modules.map(mod => <article key={mod.number} className="overflow-hidden rounded-md border border-navy/12 bg-white shadow-sm" data-id="element-108" data-mp="146xuepcs9nw7">
              <div className="flex items-center gap-1.5 bg-navy px-2.5 py-1.5" data-id="element-109" data-mp="1d6kk4dw5h59f">
                <span className="text-[0.8rem] leading-none" aria-hidden="true" data-id="element-110" data-mp="1d8nmlxehoqv1">
                  ✅
                </span>
                <h3 className="font-body text-[0.72rem] font-extrabold uppercase leading-tight tracking-wide text-white sm:text-[0.9rem]" data-id="element-111" data-mp="2olzssexq1lkd">
                  Module {mod.number} — {mod.title}
                </h3>
              </div>
              <div className="px-2.5 py-2" data-id="element-112" data-mp="1u1kpbky31jv">
                <p className="text-[0.8rem] leading-[1.35] text-muted sm:text-[0.95rem]" data-id="element-113" data-mp="1sysn0bvyt2d">
                  {mod.body}
                </p>
                <p className="mt-1 font-body text-[0.68rem] font-bold uppercase tracking-wide text-clinical sm:text-[0.8rem]" data-id="element-114" data-mp="3oz99swb12qf9">
                  {mod.steps}
                </p>
              </div>
            </article>)}
        </div>
      </div>
    </section>;
}